import {
  createRef,
  Fragment,
  FunctionComponent,
  useEffect,
  useState,
} from "react";
import {
  IPurchaseOrder,
  IPurchaseOrderListProps,
  IPurchaseOrderProps,
} from "./IPurchaseOrder";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import {
  Backdrop,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CompletePopup from "../components/response-pop-up";

import PurchaseOrderForm from "./PurchaseOrderForm";
import {
  clearEditPurchaseOrder,
  editPurchaseOrderStart,
} from "../../redux/purchase-order/editPurchaseOrder";
import { dateFormate } from "../../Utils/date-month-yearFromatter";

const PurchaseOrderList: FunctionComponent<IPurchaseOrderListProps> = (
  props
) => {
  const [open, setOpen] = useState<boolean>(false);
  const [isEdit, setEdit] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<IPurchaseOrder>({
    active: true,
  });
  const [responseEdit, setResponseEdit] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { data: editPurchaseOrder, isLoading: editPurchaseOrderLoading } =
    useAppSelector((state) => state.EditPurchaseOrder);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };

  const { purchaseOrder } = props;

  console.log("purchaseOrder-1", purchaseOrder);

  return (
    <Fragment>
      <Fragment>
        <div className="content_header justify-content-end">
          <div className="btns">
            {purchaseOrder?.ApprovalStatus === "P" ? (
              <Fragment>
                <Button
                  disableRipple
                  className="common_btn_outline"
                  onClick={() => {
                    handleClickOpen();
                    setInitialValues(purchaseOrder ?? {});
                  }}
                >
                  Reject
                </Button>
                <Button
                  disableRipple
                  className="common_btn"
                  onClick={() => {
                    dispatch(
                      editPurchaseOrderStart({
                        ...purchaseOrder,
                        ApprovalStatus: "Y",
                      })
                    );
                  }}
                >
                  Approve
                </Button>
              </Fragment>
            ) : (
              <p className="f4 primary_text">
                {(purchaseOrder?.ApprovalStatus === "N" && "Rejected") ||
                  (purchaseOrder?.ApprovalStatus === "Y" && "Approved") ||
                  purchaseOrder?.CardName}
              </p>
            )}
          </div>
        </div>

        <div className="scroll_content_container scroll_content_container_2">
          <div className="grid_container">
            <div className="detail_item">
              <label className="f4">Request Date/Time</label>
              <p>
                {purchaseOrder?.DocDate && dateFormate(purchaseOrder?.DocDate)}
              </p>
            </div>
            <div className="detail_item">
              <label className="f4">Request Sent By</label>
              <p>{purchaseOrder?.OriginatorName}</p>
            </div>
            <div className="detail_item">
              <label className="f4">Vendor Code</label>
              <p>{purchaseOrder?.VendorCode}</p>
            </div>
            <div className="detail_item">
              <label className="f4">Vendor Name</label>
              <p>{purchaseOrder?.CardName}</p>
            </div>

            <div className="detail_item">
              <label className="f4">Currency</label>
              <p>{purchaseOrder?.Currency}</p>
            </div>
            <div className="detail_item">
              <label className="f4">Document Total</label>
              <p>
                {purchaseOrder?.DocTotal &&
                  Number(purchaseOrder.DocTotal).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </p>
            </div>
            <div className="detail_item">
              <label className="f4">Remarks</label>
              <p>{purchaseOrder?.Remarks}</p>
            </div>
            <div className="detail_item">
              <label className="f4">Status</label>
              <p>{purchaseOrder?.active ? "Active" : "InActive"}</p>
            </div>
          </div>
          {purchaseOrder?.reason && (
            <div className="detail_item">
              <label className="f4">Reject Reason</label>
              <p>{purchaseOrder?.reason}</p>
            </div>
          )}
        </div>
      </Fragment>

      <Fragment>
        <Dialog
          PaperProps={{
            style: { borderRadius: 0, width: "700px" },
          }}
          open={open}
          onClose={handleClose}
          maxWidth={"md"}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="dialog_header common_border_bottom">
            <h4 id="alert-dialog-title" className="f4">
              {"Add Reason"}
            </h4>

            <CancelIcon
              onClick={() => {
                handleClose();
              }}
            />
          </div>
          <PurchaseOrderForm
            initialValues={initialValues}
            handleClose={handleClose}
            setInitialValues={setInitialValues}
          />
        </Dialog>

        {/* <CompletePopup
          data={{ data: createRetailer }}
          responsePopup={Object.keys(createRetailer ?? {}).length}
          setCompletePopup={(e: any) => {
            dispatch(clearCreateRetailerMaster());
            setResponsePopup(false);
          }}
        />*/}
        <CompletePopup
          data={{ data: editPurchaseOrder }}
          responsePopup={Object.keys(editPurchaseOrder ?? {}).length}
          setCompletePopup={(e: any) => {
            dispatch(clearEditPurchaseOrder());
            setResponseEdit(false);
          }}
        />

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={!!editPurchaseOrderLoading}
        >
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>
      </Fragment>
    </Fragment>
  );
};

export default PurchaseOrderList;
